/**
 * 未分離の ymd 系をマージして平日/土日祝分離の入力にする。
 */
export const mergeYmdListsForWeekdayHolidaySeparation = (
  ymdList: string[],
  ymdComparisonList: string[]
): string[] =>
  Array.from(new Set([...ymdList, ...ymdComparisonList])).sort((a, b) =>
    a.localeCompare(b)
  );

/**
 * 平日/土日祝比較の UI 用に ymd 系を未分離状態（同一配列）へ正規化する。
 * 店舗レポート遷移などで分離済みで渡ってきた場合も、画面内検索と同じ状態に揃える。
 */
export const normalizeWeekdayHolidayYmdListsForUiState = (
  ymdList: string[],
  ymdComparisonList: string[]
): { ymdList: string[]; ymdComparisonList: string[] } => {
  const mergedYmdList = mergeYmdListsForWeekdayHolidaySeparation(
    ymdList,
    ymdComparisonList
  );
  return {
    ymdList: mergedYmdList,
    ymdComparisonList: mergedYmdList,
  };
};
